// extracted by mini-css-extract-plugin
export var divider = "_m4-0";
export var labelWrapper = "_m4-2";
export var lineSvg = "_m4-1";